import { IconButton, Snackbar } from '@mui/material';
import { CcfCallResloveIcon } from '@nice-ccf/ui-controls';
import Alert from '@mui/lab/Alert';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ccf-toast.module.scss';
import { useDispatch } from 'react-redux';
import { updateIsQReplySent } from '../ccf-app-space/ccf-app-space.slice';

/* eslint-disable-next-line */
export interface CcfToastProps {
  open: boolean;
  type: string;
  message: string;
}

/**
 * Used to show Toast messages for the application
 * @param props -?- CcfToastProps
 * @example - `<CcfToast {...props}/>`
 */
export function CcfToast(props: CcfToastProps) {
  const dispatch = useDispatch();
  const vertical = 'bottom';
  const horizontal = 'right';

  /**
   * used to close toast message
   * @param event -?-React.SyntheticEvent
   * @param reason - string
   * @example `<handleClose />`
   */
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(updateIsQReplySent(false));
  };

  return (
    <Snackbar
      autoHideDuration={3000}
      anchorOrigin={{ vertical, horizontal }}
      open={props.open}
      onClose={() => handleClose()}
      key={vertical + horizontal}
    >
      <Alert
        variant="filled"
        severity="success"
        iconMapping={{
          success: (
            <CcfCallResloveIcon
              className={styles.successTick}
              fontSize="inherit"
            />
          ),
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              dispatch(updateIsQReplySent(false));
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        classes={{
          filledSuccess: styles.successToast,
          icon: styles.succcessTickIcon,
          action: styles.successActionIcon,
        }}
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
}

export default CcfToast;
